import styles from './Summary.module.scss'
import ToDownload2 from 'components/services/common/ToDownload2'
import toDownload2Styles from 'components/services/common/ToDownload2/ToDownload2.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface SummaryItem {
  text: string
}

interface Props {
  list: SummaryItem[]
}

const Summary: React.FC<Props> = ({ list }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.summary} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>概要</h2>
      <div className={styles.summary__inner}>
        {list.map((item, index) => (
          <p key={index} className={styles.summary__inner__item}>
            {item.text}
          </p>
        ))}
        <ToDownload2
          imgSrc="/images/img/download/application-development/thumbnail_application_dev.webp"
          alt="アプリケーション開発ガイド"
          title="アプリケーション開発ガイド"
          description="アプリ開発の要件定義・予算・ベンダー選定に活用できる資料。発注前に役立つチェックリストもあり、迷ったら読むべき一冊です。是非ご覧ください。"
          link="/download/application-development/"
          subText="サービス資料"
          className={toDownload2Styles.layoutApplication}
        />
      </div>
    </section>
  )
}

export default Summary
